module.exports = __webpack_public_path__ + "img/pic_ewm@2x.9c6a8fae.png";